import { createAction } from '@reduxjs/toolkit'

import { Notification, HideNotification, RemoveNotification } from './@types'

export const callNotification = createAction<Notification>('notifications/call_notification')
export const hideNotification = createAction<HideNotification>('notifications/hide_notification')
export const removeNotification = createAction<RemoveNotification>('notifications/remove_notification')
